/* eslint-disable react/prefer-stateless-function */
/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import React, { Component, memo } from 'react';
import get from 'lodash/get';
import ErrorBoundary from 'yoda-site-components/lib/components/ErrorBoundary/ErrorBoundary';
import ProtectionPlanLazy from 'yoda-site-components/lib/components/ProtectionPlan/ProtectionPlanLazy';
import CommonLazy from '../Common/CommonLazy';
import DeliveryOption from '../../../../components/DeliveryOption/DeliveryOption';

class Regular extends Component {
    static defaultProps = {
        query: {},
        featureFlags: {},
        location: {},
        updatedSKUId: '',
    };

    static propTypes = {
        isCollection: PropTypes.bool.isRequired,
        ppId: PropTypes.string.isRequired,
        query: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        featureFlags: PropTypes.oneOfType([PropTypes.object]),
        location: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        updatedSKUId: PropTypes.string,
    };

    render() {
        const {
            isCollection,
            ppId,
            query,
            featureFlags,
            location,
            isBeauty,
            updatedSKUId,
        } = this.props;

        return (
            <CommonLazy
                featureFlags={featureFlags}
                isCollection={isCollection}
                ppId={ppId}
                query={query}
                slot2={
                    <ErrorBoundary>
                        <DeliveryOption query={query} />
                    </ErrorBoundary>
                }
                slot4={
                    !get(featureFlags, 'disableProtectionPlan', true) && (
                        <ErrorBoundary>
                            <ProtectionPlanLazy query={query} fromMiniPDP={false} />
                        </ErrorBoundary>
                    )
                }
                location={location}
                isBeauty={isBeauty}
                updatedSKUId={updatedSKUId}
            />
        );
    }
}

export default memo(Regular);
